/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const ContinentRow = styled.div`
  display: flex;
  align-items: center;
  margin-left: 24px;
  cursor: pointer;
  height: 40px;
`;
export const ContinentTitle = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const RowName = styled.p`
  margin-left: auto;
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-right: 24px;
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${({ isOpen }) =>
    isOpen
      ? css`
          svg {
            fill: ${Palette.Primary._500};
          }
        `
      : css`
          svg {
            fill: ${Palette.PrimaryGray._400};
          }
        `}
`;
export const CountriesList = styled.div``;

export const CountryRow = styled.div`
  display: flex;
  align-items: center;
`;

export const CountryContainer = styled.div``;

export const RegionsList = styled.div``;
export const RegionsRow = styled.div`
  display: flex;
  align-items: center;
`;

export const CountryNameBox = styled.div`
  width: 145px;
`;

export const RegionNameBox = styled.div`
  width: 153px;
`;
